module.exports = __webpack_public_path__ + "static/media/result_rc_ja.25bb2d1d.jpg";